import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Card, Typography } from "antd";
import ProfileInfoTab from "./ProfileInfoTab";
import CompanyDataTab from "./CompanyDataTab";
import TeamInfoTab from "./TeamInfoTab";
import useProfile from "./useProfile";

export default function AccountPage() {
  const [selectedTab, setSelectedTab] = useState("My Profile");
  const tabs = ["My Profile", "Company Data", "Team"];

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };
  
  const getTabs = () => {
    return tabs.map((tab) => {
      return (
        <div
          className={`settings-tab ${selectedTab === tab ? "selected" : ""}`}
          onClick={() => handleTabClick(tab)}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === tab ? "selected" : ""
            }`}
          >
            {tab}
          </h4>
        </div>
      );
    });
  };

  const renderTab = () => {
    switch (selectedTab) {
      case "My Profile":
        return <ProfileInfoTab />;
      case "Company Data":
        return <CompanyDataTab />;
      case "Team":
        return <TeamInfoTab />;
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", columnGap: "0.5px" }}>
        {getTabs()}
      </div>
      <Card
        bordered={false}
        style={{ borderRadius: "0px 0px 16px 16px", padding: "45px 25px" }}
      >
        {renderTab()}
      </Card>
    </div>
  );
}
